import toExternalIcon from '../toExternalIcon';
import url from '../sprite.external.svg';

const MailchimpIcon = toExternalIcon({
  url,
  targetId: 'mailchimp',
});

export default MailchimpIcon;
